export default {
  namespaced: true,
  state: {
    count: 0,
    title: '',
    message: '',
    variant: 'success',
    timeout: 0
  },
  getters: {
    getCount (state) { return state.count }
  },
  mutations: {
    setToast (state, data) {
      state.count = state.count + 1
      state.title = data.title
      state.message = data.message
      state.variant = data.variant
      state.timeout = data.timeout
      console.log('state.variant', state.variant)
    }
  },
  actions: {
    showToast ({ commit }, toast) {
      toast.variant = toast.variant || 'success'
      if (!toast.timeout) {
        if (toast.timeout !== 0) toast.timeout = 4000
      }
      console.log('showToast', toast)
      commit('setToast', toast)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/toast.js